export const LATEST_SLUG = 'latest';
export enum PRODUCTS {
  sonarcloud = 'sonarcloud',
  sonarlint = 'sonarlint',
  sonarqube = 'sonarqube',
  sonarqube_community_build = 'sonarqube_community_build',
  sonarqube_global = 'sonarqube_global',
}
